import { useQuery } from "@tanstack/react-query";
import type { ColumnDef } from "@tanstack/react-table";
import { ShieldCheck } from "lucide-react";
import { StatusPill } from "@ocs/ui";
import { adminApi } from "../api";
import { DataTable } from "../components/DataTable";
import { amount, shortAddress } from "../format";

type Transfer = {
  transfer_batch_id: string; batch_code: string; treasury_address: string; total_amount: string;
  min_treasury_reserve: string; deadline_at: string; targets_hash: string; onchain_tx_hash: string | null;
  batch_status: number; to_address: string; pending_withdrawal_amount: string;
  safety_buffer_amount: string; required_amount: string; transfer_amount: string; created_at: string;
};

const columns: ColumnDef<Transfer>[] = [
  { header: "批次", accessorKey: "batch_code", cell: ({ getValue }) => <code>{getValue<string>()}</code> },
  { header: "目标合约", accessorKey: "to_address", cell: ({ getValue }) => <code>{shortAddress(getValue<string>())}</code> },
  { header: "提现需求 + 缓冲", cell: ({ row }) => <span className="numeric">{amount(row.original.pending_withdrawal_amount)} + {amount(row.original.safety_buffer_amount)}</span> },
  { header: "计划调拨", accessorKey: "transfer_amount", cell: ({ getValue }) => <b className="numeric">{amount(getValue<string>())} USDT</b> },
  { header: "最低储备", accessorKey: "min_treasury_reserve", cell: ({ getValue }) => <span className="numeric">{amount(getValue<string>())}</span> },
  { header: "状态", accessorKey: "batch_status", cell: ({ getValue }) => <StatusPill tone={getValue<number>() === 3 ? "success" : "warning"}>{getValue<number>() === 3 ? "链上确认" : "等待多签"}</StatusPill> },
  { header: "链上交易", accessorKey: "onchain_tx_hash", cell: ({ getValue }) => <code>{shortAddress(getValue<string | null>())}</code> }
];

export function TransferPage() {
  const query = useQuery({ queryKey: ["transfers"], queryFn: () => adminApi<Transfer[]>("/transfers"), refetchInterval: 5000 });
  return (
    <div className="transfer-page">
      <section className="read-only-banner"><ShieldCheck /><div><strong>2/3 多签操作边界</strong><span>这里展示建议与执行结果；Owners 仍在 TokenPocket 原生多签中核对 batchId、deadline、minReserve 和 targetsHash。</span></div></section>
      <DataTable data={query.data ?? []} columns={columns} emptyMessage="流动性出现资金缺口并形成多签调拨记录后，会显示在这里。" />
    </div>
  );
}
